import { createWebHistory, createRouter } from "vue-router";
import LoginComponent from "../components/Login.vue";
import HomeComponent from "../components/Home.vue";

function guardMyroute(to, from, next) {
    var isAuthenticated = false;
    //this is just an example. You will have to find a better or
    // centralised way to handle you localstorage data handling
    if (localStorage.getItem("token")) isAuthenticated = true;
    else isAuthenticated = false;
    if (isAuthenticated) {
        next(); // allow to enter route
    } else {
        next("/login"); // go to '/login';
    }
}

const routes = [
    { path: "/", name: "Home", component: HomeComponent, beforeEnter: guardMyroute },
    { path: "/login", name: "Login", component: LoginComponent },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

export default router;
